import React from "react";
import { useIntl } from "react-intl";
import { object, array, number, string } from "yup";
import { useFormikContext } from "formik";

import { Space } from "@masterteam/mt-design-react";
import Item from "./Item";

import "./style.scss";

export const statusValidationSchema = (name) =>
  object().shape({
    [name]: array().of(
      object().shape(
        {
          Min: number()
            .nullable()
            .when("MinOperator", {
              is: (val) => !!val,
              then: (schema) => schema.required(),
            }),
          Max: number()
            .nullable()
            .when("MaxOperator", {
              is: (val) => !!val,
              then: (schema) =>
                schema
                  .required()
                  .when("Min", (min, schema) => schema.min((min || 0) + 1)),
            }),
          MinOperator: string()
            .nullable()
            .when("Min", {
              is: (val) => !!val,
              then: (schema) => schema.required(),
            }),
          MaxOperator: string()
            .nullable()
            .when("Max", {
              is: (val) => !!val,
              then: (schema) => schema.required(),
            }),
        },
        [
          ["Max", "MaxOperator"],
          ["Min", "MinOperator"],
        ]
      )
    ),
  });

function StatusField({ name = [], readOnly }) {
  const intl = useIntl();
  const formBag = useFormikContext();

  const { values, setFieldValue, errors } = formBag;

  const columns = [
    {
      id: 1,
      title: intl.formatMessage({ id: "threshold.label" }),
      width: "40%",
    },
    {
      id: 2,
      title: "Low Boundery",
      title: intl.formatMessage({ id: "threshold.low-boundery" }),
      width: "11%",
    },
    {
      id: 2,
      title: intl.formatMessage({ id: "threshold.operator" }),
      width: "11%",
    },
    {
      id: 3,
      title: intl.formatMessage({ id: "common.value" }),
      width: "10%",
    },
    {
      id: 4,
      title: intl.formatMessage({ id: "threshold.operator" }),
      width: "11%",
    },
    {
      id: 5,
      title: intl.formatMessage({ id: "threshold.high-boundery" }),
      width: "11%",
    },
    {
      id: 6,
      title: intl.formatMessage({ id: "common.color" }),
      width: "11%",
    },
  ];
  return (
    <Space
      size="medium"
      direction="vertical"
      className="kpi-config__form__status-tab__listt"
    >
      <Space
        size="medium"
        className="kpi-config__form__status-tab__listt-header"
      >
        {columns?.map((e) => (
          <div
            className="kpi-config__form__status-tab__listt-header__column"
            style={{ width: e?.width }}
          >
            {e?.title}
          </div>
        ))}
      </Space>
      <Space
        direction="vertical"
        size="medium"
        className="kpi-config__form__status-tab__listt-content"
      >
        {values?.[name]?.map((e, _index) => (
          <Item
            index={_index}
            statuses={values?.[name]}
            name={name}
            key={e?.id}
            data={e}
            columns={columns}
            onChange={setFieldValue}
            errors={errors[name]?.[_index]}
            readOnly={readOnly}
          />
        ))}
      </Space>
    </Space>
  );
}

export default StatusField;
